import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0041',
    ecrans: ['00-2'],
    params:['?demcleint' ,
            '?datdeb']
});
